import { render, staticRenderFns } from "./PortefeuilleDocuments.vue?vue&type=template&id=1a3280b3&scoped=true"
import script from "./PortefeuilleDocuments.vue?vue&type=script&lang=js"
export * from "./PortefeuilleDocuments.vue?vue&type=script&lang=js"
import style0 from "./PortefeuilleDocuments.vue?vue&type=style&index=0&id=1a3280b3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a3280b3",
  null
  
)

export default component.exports